<template>
  <div class="app-main-content open-view">
    <div class="details-view" style="overflow: auto">
      <div v-show="!onlyView" style="margin-top: 5px">
        <el-button no="Back" @click="back">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
        <el-button v-permission="['button_OpenPrice_edit']" :disabled="isEditDisable" type="success" no="Edit" @click="toEdit">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
        <el-button v-permission="['button_OpenPrice_edit']" type="primary" no="add" @click="toAdd">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
        <el-button v-permission="['button_OpenPrice_edit']" type="primary" :disabled="!form" no="copy" @click="toCopy()">{{ $t('CargoMsg.Cargo_Copy') }}</el-button>
        <el-button v-permission="['button_OpenPrice_rpaControl']" type="primary" :disabled="!isRpaEnabled || !form || notRpaStart || isCompleted" no="start" @click="toStartRPA()">{{ $t('CargoMsg.Cargo_StartRPA') }}</el-button>
        <el-button v-permission="['button_OpenPrice_rpaControl']" type="danger" :disabled="!isRpaEnabled || !form || !notRpaStart || isCompleted" no="suspend" @click="toSuspendRPA()">{{ $t('CargoMsg.Cargo_SuspendRPA') }}</el-button>
        <el-button v-permission="['button_OpenPrice_importFinalResult']" type="primary" :disabled="!form" no="importFinalResult" @click="toImportFinalResult()">{{ $t('CargoMsg.Cargo_ImportFinalResult') }}</el-button>
        <el-button v-permission="['button_OpenPrice_edit']" type="primary" :disabled="!form || isCompleted" no="manuallyExportFile" @click="toExportFile">{{ $t('CargoMsg.Cargo_ManuallyExportFile') }}</el-button>
        <el-button v-permission="['button_OpenPrice_delete']" type="danger" :disabled="isDeleteDisable" no="delete" @click="toDelete()">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
      </div>
      <div class="main-content">
        <div class="section" style="margin-top:5px;width:100%">
          <div>
            <span class="title">{{ $t('CargoMsg.Cargo_FilingBatchInfo') }}</span>
            <span style="margin-left:50px;font-size:15px;">{{ filingStateLabel }}</span>
          </div>
          <el-form :inline="true" label-width="80px" label-position="right">
            <el-row type="flex">
              <el-col :span="onlyView?5:4">
                <el-form-item :label="$t('CargoMsg.Cargo_FilingBatchNo')">
                  <el-input v-model="form.filingBatchNo" :disabled="true" />
                </el-form-item>
              </el-col>
              <el-col :span="onlyView?5:4">
                <el-form-item :label="$t('CargoMsg.Cargo_FilingDate')">
                  <el-date-picker
                    v-model="form.filingDate"
                    :disabled="true"
                    no="customsDate"
                    type="date"
                    style="width:100%"
                    value-format="yyyy-MM-dd"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="onlyView?5:4">
                <el-form-item :label="$t('CargoMsg.Cargo_EffectiveDate')">
                  <el-date-picker
                    v-model="form.effectiveDate"
                    :disabled="true"
                    no="customsDate"
                    type="date"
                    style="width:100%"
                    value-format="yyyy-MM-dd"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
                  <el-input v-model="form.filingRemark" style="width:200px" :disabled="true" />
                </el-form-item>
              </el-col>
              <el-col :span="onlyView?3:6" />
            </el-row>
            <el-row type="flex">
              <el-col :span="onlyView?6:5">
                <el-form-item label-width="80px" :label="$t('CargoMsg.Cargo_DeclareFile')">
                  <p style="margin-top:0px;margin-bottom:0px;"><a style="color:blue" @click="handleExport(form.uploadFileId)">{{ form.uploadFileName }}</a></p>
                </el-form-item>
              </el-col>
              <el-col :span="onlyView?8:7">
                <el-form-item label-width="100px" :label="$t('CargoMsg.Cargo_ImportFinalFile')">
                  <p style="margin-top:0px;margin-bottom:0px;"><a style="color:blue" @click="handleExport(form.importResultFileId)">{{ form.importResultFileName }}</a></p>
                </el-form-item>
              </el-col>
              <el-col :span="onlyView?6:5">
                <el-form-item label-width="180px" :label="$t('CargoMsg.Cargo_FiletotalRecordPass')">
                  <el-input v-model="form.filetotalRecordPass" style="width:140px" :disabled="true" />
                </el-form-item>
              </el-col>
              <el-col :span="onlyView?4:7">
                <el-form-item label-width="0px">
                  <p style="margin-top:0px;margin-bottom:0px;font-size:14px;color:red;">{{ $t('CargoMsg.Cargo_DeclareFinalLabel', [form.declareFinal]) }}</p>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="tabs-container">
          <el-tabs v-model="activeTabName" :lazy="true" type="card" style="width:100%;">
            <el-tab-pane :label="$t('CargoMsg.Cargo_FinalPriceInfo')" name="finalPrice">
              <div class="grid-wrapper" style="padding-top:5px;height:100%">
                <cargo-ag-grid
                  ref="tabFinalPrice"
                  :grid-options="tabFinalPrice.gridOptions"
                  :column-defs="tabFinalPrice.columnDefs"
                  :row-data="tabFinalPrice.rowData"
                  :show-side-bar="false"
                  :auto-fit-content="false"
                />
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_OpenPriceInfo')" name="openPrice">
              <div class="grid-wrapper" style="padding-top:5px;height:100%">
                <cargo-ag-grid
                  ref="tabOpenPrice"
                  :grid-options="tabOpenPrice.gridOptions"
                  :column-defs="dynamicColumnDefs"
                  :grid-params.sync="tabOpenPrice.gridParams"
                  :row-data="tabOpenPrice.rowData"
                  :show-side-bar="false"
                  :auto-fit-content="false"
                />
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_Log')" name="opLog">
              <div class="grid-wrapper" style="padding-top:5px;height:100%">
                <cargo-ag-grid
                  ref="tabOpLog"
                  :grid-options="tabOpLog.gridOptions"
                  :column-defs="tabOpLog.columnDefs"
                  :row-data="tabOpLog.rowData"
                  :show-side-bar="false"
                  :auto-fit-content="false"
                />
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { detailOpenPriceBatch } from '@/api/price/openPrice'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import URL from '@/api/urlTranslator'

export default {
  name: 'OpenPriceView',
  props: {
    source: { type: String, default: '' },
    dataChanged: { type: Boolean, default: false }, // 是否变更过
    rpaEnabled: { type: Boolean, default: false }, // 是否启用RPA
    onlyView: { type: Boolean, default: false }, // 是否仅查看
    companyCodes: { type: Array, default: () => [] }, // 公司代码
    lanes: { type: Array, default: () => [] }, // 航线
    eqSizes: { type: Array, default: () => [] }, // 尺码
    eqTypes: { type: Array, default: () => [] }, // 箱型
    cargoTypes: { type: Array, default: () => [] }, // 货种
    seaports: { type: Array, default: () => [] } // 海港
  },
  data() {
    return {
      innerVisible: false,
      SystemConstants,
      loading: false,
      TYPE_NAMES,
      form: {},
      originForm: {},
      abcs: [{ code: 'A' }, { code: 'B' }, { code: 'C' }], // ABC
      departureDays: SystemConstants.WEEKS, // 周班
      tabOpenPrice: {
        columnDefs: [],
        gridOptions: {},
        gridParams: {},
        rowData: []
      },
      tabFinalPrice: {
        gridOptions: {},
        gridParams: {},
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_SequenceNumber'), colId: 'serialNumber', field: 'serialNumber', initialWidth: 60, minWidth: 60,
            headerClass: 'ag-header-cell-center',
            cellStyle: {
              textAlign: 'center'
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CompanyCode2'), colId: 'companyCode', field: 'companyCode', initialWidth: 100, minWidth: 100,
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Lane'), colId: 'lane', field: 'lane', initialWidth: 120, minWidth: 120,
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_DepartureDay'), field: 'departureDay', colId: 'departureDay', initialWidth: 100, minWidth: 100,
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            },
            valueFormatter: (params) => {
              return !params.value ? '' : ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.WEEKS)
            }
          },
          {
            headerName: 'ABC', colId: 'abc', field: 'abc', initialWidth: 80, minWidth: 80,
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_StartingPort'), colId: 'pol', field: 'pol', initialWidth: 120, minWidth: 120,
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_POD'), colId: 'pod', field: 'pod', initialWidth: 120, minWidth: 120,
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ContainerSize'), colId: 'eqType', field: 'eqType', initialWidth: 80, minWidth: 80,
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CargoType2'), colId: 'cargoType', field: 'cargoType', initialWidth: 80, minWidth: 80,
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_EqSize'), colId: 'eqSize', field: 'eqSize', initialWidth: 80, minWidth: 80,
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Cost2'), colId: 'cost', field: 'cost', initialWidth: 100, minWidth: 100,
            headerClass: 'ag-header-cell-right',
            cellStyle: {
              textAlign: 'right'
            },
            valueFormatter: (params) => {
              return !params.value ? '' : this.$numeral(params.value).format('0.00')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CostMin'), colId: 'costMin', field: 'costMin', initialWidth: 100, minWidth: 100,
            headerClass: 'ag-header-cell-right',
            cellStyle: {
              textAlign: 'right'
            },
            valueFormatter: (params) => {
              return !params.value ? '' : this.$numeral(params.value).format('0.00')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CostMax'), colId: 'costMax', field: 'costMax', initialWidth: 100, minWidth: 100,
            headerClass: 'ag-header-cell-right',
            cellStyle: {
              textAlign: 'right'
            },
            valueFormatter: (params) => {
              return !params.value ? '' : this.$numeral(params.value).format('0.00')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Commission'), colId: 'commission', field: 'commission', initialWidth: 80, minWidth: 80,
            headerClass: 'ag-header-cell-right',
            cellStyle: {
              textAlign: 'right'
            },
            valueFormatter: (params) => {
              if (!params.value) {
                return ''
              }
              return !params.value ? '' : this.$numeral(params.value).format('0.00')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_EqDeduct'), colId: 'eqDeduct', field: 'eqDeduct', initialWidth: 80, minWidth: 80,
            headerClass: 'ag-header-cell-right',
            cellStyle: {
              textAlign: 'right'
            },
            valueFormatter: (params) => {
              return !params.value ? '' : this.$numeral(params.value).format('0.00')
            }
          },
          {
            headerName: 'BAF', colId: 'baf', field: 'baf', initialWidth: 80, minWidth: 80,
            headerClass: 'ag-header-cell-right',
            cellStyle: {
              textAlign: 'right'
            },
            valueFormatter: (params) => {
              return !params.value ? '' : this.$numeral(params.value).format('0.00')
            }
          },
          {
            headerName: 'CAF', colId: 'caf', field: 'caf', initialWidth: 80, minWidth: 80,
            headerClass: 'ag-header-cell-right',
            cellStyle: {
              textAlign: 'right'
            },
            valueFormatter: (params) => {
              return !params.value ? '' : this.$numeral(params.value).format('0.00')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_OtherSurcharge'), colId: 'otherSurcharge', field: 'otherSurcharge', initialWidth: 120, minWidth: 120,
            headerClass: 'ag-header-cell-right',
            cellStyle: {
              textAlign: 'right'
            },
            valueFormatter: (params) => {
              return !params.value ? '' : this.$numeral(params.value).format('0.00')
            }
          },
          {
            headerName: 'O.THC', colId: 'othc', field: 'othc', initialWidth: 80, minWidth: 80,
            headerClass: 'ag-header-cell-right',
            cellStyle: {
              textAlign: 'right'
            },
            valueFormatter: (params) => {
              return !params.value ? '' : this.$numeral(params.value).format('0.00')
            }
          },
          {
            headerName: 'D.THC', colId: 'dthc', field: 'dthc', initialWidth: 80, minWidth: 80,
            headerClass: 'ag-header-cell-right',
            cellStyle: {
              textAlign: 'right'
            },
            valueFormatter: (params) => {
              return !params.value ? '' : this.$numeral(params.value).format('0.00')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FilingDate'), colId: 'filingDate', field: 'filingDate', initialWidth: 130, minWidth: 130,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_EffectiveDate'), colId: 'effectiveDate', field: 'effectiveDate', initialWidth: 130, minWidth: 130,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Remarks'), colId: 'remarks', field: 'remarks', initialWidth: 150, minWidth: 150,
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            }
          }
        ],
        rowData: []
      },
      tabOpLog: {
        gridOptions: {},
        gridParams: {},
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_Time'), colId: 'opDate', field: 'opDate', initialWidth: 140, minWidth: 140, sortable: false,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_OperateBy'), colId: 'opBy', field: 'opBy', initialWidth: 120, minWidth: 120, sortable: false,
            headerClass: 'ag-header-cell-center', cellStyle: { textAlign: 'center' },
            cellRenderer: (params) => {
              if (!params.value) {
                return 'RPA'
              } else {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
              }
            }
          },
          {
            headerName: this.$t('SeaExport.Content'), colId: 'message', field: 'message', initialWidth: 900, minWidth: 900, sortable: false
          }
        ],
        rowData: []
      },
      activeTabName: 'openPrice'
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    // 已完成
    isCompleted() {
      if (this.form && this.form.filingState === SystemConstants.OPEN_PRICE_BATCH_COMPLETED.code) {
        return true
      }
      return false
    },
    // 执行中、暂停、已完成状态，禁用编辑按钮
    isEditDisable() {
      if (this.form && (this.form.filingState === SystemConstants.OPEN_PRICE_BATCH_PROCESSING.code ||
        this.form.filingState === SystemConstants.OPEN_PRICE_BATCH_PAUSE.code ||
        this.form.filingState === SystemConstants.OPEN_PRICE_BATCH_COMPLETED.code)) {
        return true
      }
      return false
    },
    // 执行中、已完成状态，禁用删除按钮
    isDeleteDisable() {
      if (this.form && (this.form.filingState === SystemConstants.OPEN_PRICE_BATCH_PROCESSING.code ||
        this.form.filingState === SystemConstants.OPEN_PRICE_BATCH_COMPLETED.code)) {
        return true
      }
      return false
    },
    filingStateLabel() {
      return ColumnUtils.OpenPriceBatchStateLabelFun(this.form.filingState)
    },
    dynamicColumnDefs() {
      const result = [
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'), colId: 'serialNumber', field: 'serialNumber', initialWidth: 60, minWidth: 60,
          headerClass: 'ag-header-cell-center',
          cellStyle: {
            textAlign: 'center'
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CompanyCode2'), colId: 'companyCode', field: 'companyCode', initialWidth: 100, minWidth: 100,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Lane'), colId: 'lane', field: 'lane', initialWidth: 120, minWidth: 120,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          valueFormatter: (params) => {
            if (params.value) {
              const item = this.lanes.find(p => p.code === params.value)
              if (item) {
                return this.isZh && item.name ? `[${item.code}]${item.name}` : `[${item.code}]${item.nameEnglish}`
              }
            }
            return params.value
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DepartureDay'), field: 'departureDay', colId: 'departureDay', initialWidth: 100, minWidth: 100,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          valueFormatter: (params) => {
            if (params.value) {
              return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.WEEKS)
            }
            return ''
          }
        },
        {
          headerName: 'ABC', colId: 'abc', field: 'abc', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_StartingPort'), colId: 'pol', field: 'pol', initialWidth: 120, minWidth: 120,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          valueFormatter: (params) => {
            if (params.value) {
              const item = this.seaports.find(p => p.code === params.value)
              if (item) {
                return CustomLableUtils.getPortLabel(item, 'auto_7')
              }
            }
            return params.value
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_POD'), colId: 'pod', field: 'pod', initialWidth: 120, minWidth: 120,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          valueFormatter: (params) => {
            if (params.value) {
              const item = this.seaports.find(p => p.code === params.value)
              if (item) {
                return CustomLableUtils.getPortLabel(item, 'auto_7')
              }
            }
            return params.value
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContainerSize'), colId: 'eqType', field: 'eqType', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CargoType2'), colId: 'cargoType', field: 'cargoType', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EqSize'), colId: 'eqSize', field: 'eqSize', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Cost2'), colId: 'cost', field: 'cost', initialWidth: 100, minWidth: 100,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CostMin'), colId: 'costMin', field: 'costMin', initialWidth: 100, minWidth: 100,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CostMax'), colId: 'costMax', field: 'costMax', initialWidth: 100, minWidth: 100,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Commission'), colId: 'commission', field: 'commission', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EqDeduct'), colId: 'eqDeduct', field: 'eqDeduct', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: 'BAF', colId: 'baf', field: 'baf', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: 'CAF', colId: 'caf', field: 'caf', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OtherSurcharge'), colId: 'otherSurcharge', field: 'otherSurcharge', initialWidth: 120, minWidth: 120,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: 'O.THC', colId: 'othc', field: 'othc', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: 'D.THC', colId: 'dthc', field: 'dthc', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'), colId: 'remarks', field: 'remarks', initialWidth: 150, minWidth: 150,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          }
        }
      ]
      return result
    },
    // 能否启动RPA
    notRpaStart() {
      if (this.form && this.form.rpaState === SystemConstants.OPEN_PRICE_RPA_START.code) {
        return true
      }
      return false
    },
    // 是否启用RPA
    isRpaEnabled() {
      return this.rpaEnabled
    }
  },
  created() {
    this.defaultActiveTabName()
  },
  methods: {
    defaultActiveTabName() {
      if (this.isCompleted) {
        this.activeTabName = 'finalPrice'
      } else {
        this.activeTabName = 'openPrice'
      }
    },
    async init() {
      if (this.form.uuid) {
        this.detail()
      }
    },
    // 获取详情
    detail() {
      this.loading = getLoading4Cxt()
      detailOpenPriceBatch({ batchUuid: this.form.uuid, priceView: true }).then(res => {
        this.originForm = res.data
        this.setForm(this.originForm)
      }).finally(() => {
        this.loading.close()
      })
    },
    setForm(form) {
      this.form = form
      this.tabOpenPrice.rowData = this.form.openPriceList || []
      this.tabOpLog.rowData = this.form.oplogList || []
      this.tabFinalPrice.rowData = this.form.finalPriceList || []
    },
    // 返回
    back() {
      if (this.dataChanged) {
        this.$emit('back', this.source)
      } else {
        this.$emit('cancel', this.source)
      }
    },
    // 编辑
    toEdit() {
      this.$emit('edit', 'priceView')
    },
    // 新增
    toAdd() {
      this.$emit('add', 'priceView')
    },
    // 复制
    toCopy() {
      this.$emit('copy', 'priceView')
    },
    // 启动RPA
    toStartRPA() {
      this.$emit('startRpa', 'priceView')
    },
    // 暂停RPA
    toSuspendRPA() {
      this.$emit('suspendRpa', 'priceView')
    },
    // 导入最终结果
    toImportFinalResult() {
      this.$emit('importFinalResult', 'priceView')
    },
    // 手动导出文件
    toExportFile() {
      this.$emit('exportFile', 'priceView')
    },
    // 删除
    toDelete() {
      this.$emit('delete', 'priceView')
    },
    // 下载文件
    handleExport(fileId) {
      if (fileId) {
        const url = `${URL.common.findByFileId}/${fileId}?sessionId=${this.$store.getters.token}`
        window.open(url)
      }
    }
  }
}
</script>
